<template>
    <div>
        <table class="table">
            <thead>
                <tr>
                    <th class="mw-70">ID</th>
                    <th>Task Name</th>
                    <th>Next Run Time</th>
                    <th>Started At</th>
                    <th>PID</th>
                    <th>Fail Delay</th>
                    <th>Custom Data</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(task, index) in taskList" :key="task.id">
                    <td>{{ task.id }}</td>
                    <td>{{ task.classname }}</td>
                    <td>{{ dateFormat(task.nextruntime) }}</td>
                    <td>{{ task.timestarted ? dateFormat(task.timestarted) : '-' }}</td>
                    <td>{{ task.pid }}</td>
                    <td>{{ task.faildelay }}</td>
                    <td>{{ task.customdata }}</td>
                    <td>
                        <app-button type="primary" v-on:click="deleteTask(task.id)">
                            <ion-icon name="trash-outline"></ion-icon>
                            Delete
                        </app-button>
                    </td>
                </tr>

                <tr v-if="taskList.length === 0">
                    <td class="table-empty" colspan="8">No tasks!</td>
                </tr>
            </tbody>
        </table>

        <loading-overlay :loading="loading"></loading-overlay>
    </div>
</template>

<script>
import moment from "moment";
import axios from "axios";

export default {
    props: {
        tasksList: {
            type: String,
            default: ''
        },
        connection: {
            type: String,
            default: 0
        }
    },

    data() {
        return {
            connectionId: this.connection,
            taskList: {},
            loading: false
        }
    },

    created() {
        this.renderList();
    },

    methods: {
        renderList() {
            this.taskList = this.tasksList.length > 0
                ? JSON.parse(this.tasksList)
                : {};
        },
        dateFormat(date) {
            return moment.unix(date).utc().format('DD MMM YYYY HH:mm:ss');
        },
        deleteTask(taskId) {
            if (!confirm('Are you sure want to delete this task?')) {
                return;
            }

            this.loading = true;
            return axios.post(this.route('moodle.delete-adhoc-task', {connection: this.connectionId, taskId: taskId}))
                .then(response => {
                    console.log(response)
                    if (response.data.status == 'success') {
                        this.$notifications.success(response.data.message);
                    } else {
                        this.$notifications.error('Error during adhoc task deletion:' + response.data.message);
                    }
                    this.loading = false;
                    location.reload();
                })
        },
    }
}
</script>
